import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IWallet, IWalletModal, IWalletTransaction } from '../types/wallet.types';

interface WalletState extends BaseDataReducerInitialState<IWalletTransaction> {
  perPage: number;
  currentModal: IWalletModal | null;
  wallet: IWallet | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IWalletTransaction, WalletState>('crypto-wallet');

const walletState: WalletState = {
  ...initialState,
  perPage: 10,
  wallet: null,
  currentModal: null,
};

export const wallet = createSlice({
  name: 'wallet',
  initialState: walletState,
  reducers: {
    setWallet(state, action: PayloadAction<IWallet | null>) {
      state.wallet = action.payload;
    },
    setWalletModal: (state, action: PayloadAction<IWalletModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as WalletState, action);
    });
  },
});
export const WalletAC = AC;
export const onWalletFilter = thunks.onFilter;
export const clearWalletFilters = AC.clearFilters;
export const setWalletCurrentPage = AC.setCurrentPage;
export const { setWallet, setWalletModal } = wallet.actions;
